import { GridCellProps } from '@progress/kendo-react-grid';
import { TextBoxChangeEvent } from '@progress/kendo-react-inputs';
import React, { useCallback, useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import TextInput from 'src/components/TextInput';
import { isButtonEnabled } from 'src/components/design-system/Button';
import { getBgColor } from 'src/utils/icons';

const EditInput: React.ComponentType<GridCellProps> = (props) => {
  const { dataItem, field = '' } = props;
  const value = dataItem[field];

  const handleChange = useCallback(
    (e: TextBoxChangeEvent) => {
      props?.onChange?.({
        dataIndex: props.dataItem,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.value,
      });
    },
    [props]
  );
  const errors = useMemo(() => dataItem?.errors?.[field] || [], [dataItem?.errors, field]);
  const warnings = useMemo(() => dataItem?.warnings?.[field] || [], [dataItem?.warnings, field]);

  return (
    <GridCellBase {...props} className={getBgColor(errors, warnings)}>
      {isButtonEnabled(dataItem?.canDeleteReceiptLineItem) ? (
        <TextInput
          value={value}
          valid={!warnings?.length && !errors?.length}
          onChange={handleChange}
        />
      ) : (
        value || ''
      )}
    </GridCellBase>
  );
};
export default EditInput;
